import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rateAriaDescription: {
    defaultMessage: 'Rate',
    description: 'Aria label for the rate amount',
    id: 'XEmAw2',
  },
});
